import React from "react";

import { CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const mergeOptionsWithValue = (options, value) => {
  if (!value?.id) {
    return options;
  }

  return options.some((option) => Number(option.id) === Number(value.id))
    ? options
    : [value, ...options];
};

const ContactAutocomplete = ({
  value,
  options,
  loading,
  label,
  onChange,
  onInputChange,
  className,
  disabled,
}) => (
  <Autocomplete
    fullWidth
    clearOnEscape
    options={mergeOptionsWithValue(options, value)}
    value={value}
    loading={loading}
    disabled={disabled}
    getOptionLabel={(option) =>
      option?.number ? `${option.name} - ${option.number}` : option?.name || ""
    }
    getOptionSelected={(option, selected) =>
      Number(option?.id) === Number(selected?.id)
    }
    onChange={(event, newValue) => onChange(newValue)}
    onInputChange={(event, inputValue) => onInputChange(inputValue)}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        variant="outlined"
        size="small"
        className={className}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={18} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
);

export default ContactAutocomplete;
